(() => {
  const initSliderControls = () => {
    document.querySelectorAll('[data-tf-home-slider-controls]').forEach((controls) => {
      const targetId = controls.dataset.target;
      const slider = targetId ? document.getElementById(targetId) : null;
      const previous = controls.querySelector('[data-direction="previous"]');
      const next = controls.querySelector('[data-direction="next"]');

      if (!slider || !previous || !next || controls.dataset.initialized === 'true') return;

      controls.dataset.initialized = 'true';

      const getStep = () => {
        const firstItem = slider.firstElementChild;
        const styles = window.getComputedStyle(slider);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;

        return firstItem ? firstItem.getBoundingClientRect().width + gap : slider.clientWidth * 0.86;
      };

      const update = () => {
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        const hasOverflow = maxScroll > 2;

        controls.toggleAttribute('hidden', !hasOverflow);
        previous.disabled = !hasOverflow || slider.scrollLeft <= 2;
        next.disabled = !hasOverflow || slider.scrollLeft >= maxScroll - 2;
      };

      previous.addEventListener('click', () => {
        slider.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        slider.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      slider.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      if ('ResizeObserver' in window) {
        new ResizeObserver(update).observe(slider);
      }

      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliderControls);
  } else {
    initSliderControls();
  }
})();
